<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [style]="{ width: '92vw', maxWidth: '620px' }"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <span [translate]="'SDS_PUBLIC_LIST_QR_TITLE'"></span>
  </ng-template>

  <ng-container *ngIf="qrCode; else emptyQrCode">
    <ng-container
      *ngTemplateOutlet="
        isRevoking ? revokeConfirmBody : (isRegenerating ? regenerateConfirmBody : qrCodeBody)
      "
    ></ng-container>
  </ng-container>
</p-dialog>

<!-- View 1: no QR code yet -->
<ng-template #emptyQrCode>
  <p class="sds-qr-intro" [translate]="'SDS_PUBLIC_LIST_QR_DESCRIPTION'"></p>

  <div class="sds-qr-placeholder">
    <i class="pi pi-qrcode"></i>
    <span [translate]="'SDS_PUBLIC_LIST_QR_NONE'"></span>
  </div>

  <div class="sds-qr-footer" *ngIf="canManage">
    <div class="sds-qr-expiry">
      <label for="sdsQrExpirationDate" [translate]="'OPTIONAL_EXPIRATION_DATE'"></label>
      <p-datepicker
        inputId="sdsQrExpirationDate"
        [(ngModel)]="expirationDate"
        [showClear]="true"
        [minDate]="minDate"
        appendTo="body"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
      ></p-datepicker>
    </div>

    <button class="btn sds-btn-primary" type="button" (click)="createQrCode()" [disabled]="isLoading">
      <i class="pi pi-plus"></i>
      <span [translate]="'SDS_PUBLIC_LIST_QR_GENERATE'"></span>
    </button>
  </div>
</ng-template>

<!-- View 2: the live QR code -->
<ng-template #qrCodeBody>
  <div class="sds-qr-meta">
    <div>
      <strong><span [translate]="'QR_CODE_GENERATED_AT'"></span>:</strong>
      <span>{{ qrCode?.Created?.CreatedOn | date: 'dd.MM.yyyy HH:mm' }}</span>
    </div>
    <div>
      <strong><span [translate]="'EXPIRATION_DATE'"></span>:</strong>
      <span>{{ displayExpirationDate() }}</span>
    </div>
  </div>

  <div class="sds-qr-canvas">
    <qrcode
      #qrCodeElement
      [qrdata]="qrCode?.QrCodeUrl"
      [width]="280"
      [margin]="2"
      [errorCorrectionLevel]="'M'"
      [elementType]="'canvas'"
    ></qrcode>
  </div>

  <div class="sds-qr-link">
    <span class="sds-qr-link-url">{{ qrCode?.QrCodeUrl }}</span>
    <div class="sds-qr-link-actions">
      <button
        class="btn btn-outline-secondary btn-sm"
        type="button"
        (click)="copyLink()"
        [pTooltip]="'SDS_COPY_LINK' | translate"
        tooltipPosition="top"
      >
        <i class="pi pi-copy"></i>
        <span [translate]="'SDS_COPY_LINK'"></span>
      </button>
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="openLink()">
        <i class="pi pi-external-link"></i>
        <span [translate]="'SDS_OPEN_LINK'"></span>
      </button>
    </div>
  </div>

  <div class="sds-qr-footer">
    <button class="btn btn-outline-primary" type="button" (click)="downloadQrCode()">
      <i class="pi pi-download"></i>
      <span [translate]="'SDS_PUBLIC_LIST_QR_DOWNLOAD'"></span>
    </button>
    <button class="btn btn-outline-primary" type="button" (click)="printQrCode()">
      <i class="pi pi-print"></i>
      <span [translate]="'PRINT_QR_CODE'"></span>
    </button>
    <button
      class="btn btn-outline-secondary"
      type="button"
      *ngIf="canManage"
      (click)="onRegenerate()"
      [disabled]="isLoading"
    >
      <i class="pi pi-refresh"></i>
      <span [translate]="'SDS_PUBLIC_LIST_QR_REGENERATE'"></span>
    </button>
    <button
      class="btn btn-danger"
      type="button"
      *ngIf="canManage"
      (click)="onRevokeQrCode()"
      [disabled]="isLoading"
    >
      <i class="pi pi-trash"></i>
      <span [translate]="'REVOKE_QR_CODE'"></span>
    </button>
  </div>
</ng-template>

<!-- View 3: confirm regenerate -->
<ng-template #regenerateConfirmBody>
  <div class="sds-qr-confirm">
    <i class="pi pi-exclamation-triangle sds-qr-warning-icon"></i>
    <p [translate]="'SDS_PUBLIC_LIST_QR_REGENERATE_CONFIRMATION'"></p>
  </div>

  <div class="sds-qr-footer">
    <button class="btn btn-secondary" type="button" (click)="onCancelRegenerate()">
      <span [translate]="'CANCEL'"></span>
    </button>
    <button class="btn sds-btn-primary" type="button" (click)="createQrCode()" [disabled]="isLoading">
      <i class="pi pi-refresh"></i>
      <span [translate]="'SDS_PUBLIC_LIST_QR_REGENERATE'"></span>
    </button>
  </div>
</ng-template>

<!-- View 4: confirm revoke -->
<ng-template #revokeConfirmBody>
  <div class="sds-qr-confirm">
    <i class="pi pi-exclamation-triangle sds-qr-warning-icon"></i>
    <p [translate]="'SDS_PUBLIC_LIST_QR_REVOKE_CONFIRMATION'"></p>
    <p class="sds-qr-confirm-note" [translate]="'NEW_QR_CODE_IF_REENABLE_MESSAGE'"></p>
  </div>

  <div class="sds-qr-footer">
    <button class="btn btn-secondary" type="button" (click)="onCancelRevoke()">
      <span [translate]="'CANCEL'"></span>
    </button>
    <button class="btn btn-danger" type="button" (click)="onConfirmRevoke()" [disabled]="isLoading">
      <i class="pi pi-trash"></i>
      <span [translate]="'CONFIRM'"></span>
    </button>
  </div>
</ng-template>
